import { Component, OnInit, ViewChild } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { RawdataFinderService } from "app/main/pagina/tools/rawdata-finder/rawdata-finder.service";
import { lang_rawdatafinder } from 'app/idiomas/i18n/rawdata/rawdatafinder.lang';
import {TranslateService} from '@ngx-translate/core';
import { zonasUTC } from 'app/main/pagina/zonasUtc';

const _ = require('lodash');
const moment = require('moment');
const momentTz = require('moment-timezone');
@Component({
  selector: 'app-rawdata-finder',
  templateUrl: './rawdata-finder.component.html',
  styleUrls: ['./rawdata-finder.component.scss'],
  animations   : fuseAnimations
})
export class RawdataFinderComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  columnasResultado: string[] = ['nombre','surveytoken','tiporawdata','fecha','acciones'];
  resultados: MatTableDataSource<any>;
  totalResultados = 0;

  campos = [
    {
      clave: 'anio',
      icono: 'calendar_today',
      activo: true,
      catalogo: [
        { anio: '2020' },
        { anio: '2021' },
        { anio: '2022' },
        { anio: '2023' },
      ]
    },
    {
      clave: 'broker',
      icono: 'flag',
      activo: false
    }
  ];

  valores = {
    anio: null,
    broker: null
  };

  busquedaIniciada: boolean;
  buscando: boolean;

  zonaActual: any;
  offsetPipe: any;
  idiomaUtc: any;

  nivelUsuario: any;

  constructor(
    private rfsService: RawdataFinderService,
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_rawdatafinder.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaUtc = this.translateSrv.currentLang; });
  }

  ngOnInit(): void {
    // this.zonaOffset();
    this.getInstitutos();
    this.idiomaUtc = this.translateSrv.currentLang;
    this.nivelUsuario = parseInt(localStorage.getItem('levelUser_tmp'));
    console.log("nivel usuario:",this.nivelUsuario);

    if(this.nivelUsuario == 3){
      this.campos[1].activo = true;
      console.log("this.campos:",this.campos);

    }
  }

  getInstitutos(){
    this.rfsService.getInstitutos().subscribe((respuesta:any) => {
      console.log("getInstitutos:",respuesta);
      if(respuesta.success){
        let arregloBrokers = [];
        respuesta.Institutos.forEach(broker => {
          arregloBrokers.push({
            numInstituto: broker.numInstituto,
            anio: broker.numInstituto,
            traducible: true
          });
        });
        console.log("this.campos.",this.campos);

        let objBroker: any = this.campos.find(item => item.clave == 'broker');
        objBroker.catalogo = arregloBrokers;
      }
    });
  }

  verDatos(){
    console.log("datos actuales:",this.valores);

  }

  // async getRawDatas(anio:any){
  async getRawDatas(){
    let status = false;
    if(this.nivelUsuario == 3){
      if(this.valores.anio != null && this.valores.broker != null){
        status = true;
      }
    } else{
      if(this.valores.anio != null){
        status = true;
      }
    }
    if(status == true){
      this.busquedaIniciada = true;
      this.buscando = true;
      const resultado: any = await this.rfsService.getRawDatas(this.valores).toPromise().then((respuesta:any) => {return respuesta});
      console.log("getRawDatas:",resultado);
      if(resultado.success == true){
        this.llenaTablaRawdatas(resultado.result);
      } else{
        this.buscando = false;
      }
    }
  }

  llenaTablaRawdatas(arreglo:any){
    // if(!_.isEqual(stepsOriginal, refSteps)){
    //     this.ejecutaOperacionBD({ tipo: 'completaPaso' });
    //   }
    // arreglo.forEach(producto => {
    //   producto.FechaHoraUTC0_Cierre = moment(producto.FechaHoraUTC0_Cierre).format();
    // });
    this.totalResultados = arreglo.length;
    this.resultados = new MatTableDataSource<any>(arreglo);
    setTimeout(() => this.resultados.paginator = this.paginator);
    this.buscando = false;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.resultados.filter = filterValue.trim().toLowerCase();
  }

  descargar(link:string){

  }

  zonaOffset(){
    // let zonasUTC = zonasUTC;
    this.zonaActual = zonasUTC.find(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));

    const diferenciaUtc = moment.parseZone(momentTz.tz(this.zonaActual.zona).format()).utcOffset();
    // console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

}
